module.exports = __webpack_public_path__ + "static/founder-sn-30fdca89c33677c729284f3c76cff9ea.png";